import SearchForm1 from "./SearchForm1";
import Frame from "../../frame";
import { useState } from "react";
import format from "date-fns/format";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import TotalCard from "../../TotalCard";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Loader from "../../loader";
import { Grid, Typography } from "@mui/material";
import customToolbar from "../../customToolbar";
import CumulativeChart from "./cumulativeChart";
import DatewiseChart from "./datewiseChart";
import constants from "../../../constants";
import useFormData from "../../../useFormData";

function Dashboard() {

    let [data, setData] = useState(null);
    let [err, setError] = useState(null);
    let [form, setForm] = useState(null);
    let [nodata, setNodata] = useState(false);

    let [showLoader, setShowLoader] = useState(false);

    let dispatch = useDispatch();
    const currentUser = useSelector(state => state.session.currentUser);
    let navigate = useNavigate();

    let config = useSelector(state => state.session.config);

    const getFormData = useFormData();

    if (!currentUser) {
        navigate('/login');
    }

    async function handleSubmit(form) {
        console.log(form);

        // fetch('http://localhost').then((response) => response.json()).then((value) => {
        //     setData(value);
        //     setForm(form);
        // }).catch(e => {
        //     setError('Error fetching');
        // })
        setShowLoader(true);
        setNodata(false);

        //http://10.230.32.206/BigBoss_Reports/api.php?action=CumulativeData&startDate=2023-09-04%2000%3A00%3A00&endDate=2023-09-04%2016%3A59%3A59'

        let s = format(form.startDate, 'dd-MM-yyyy');
        s += 'T00:00:00';
        let e = format(form.endDate, 'dd-MM-yyyy');
        e += 'T23:59:59';
        let a = 'CumulativeData';

        if (form.type === 'cumulative') {
            a = 'CumulativeData';
        } else {
            a = 'DaywiseData';
        }

        try {
            // const response = await axios.post(`${config.reportsURL}?action=${a}&startDate=${s}&endDate=${e}`, {}, {
            //     timeout: config.apiTimeOut
            // });

            let formData = getFormData();
            formData.append("action", a);
            formData.append("startDate", s);
            formData.append("endDate", e);

            const response = await axios.post(`${config.reportsURL}`, formData, {
                timeout: config.apiTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (response.data.data && Array.isArray(response.data.data.votes) && response.data.data.votes.length > 0) {
                        setData(response.data.data);
                        setForm(form);
                    } else {
                        setNodata(true);
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
            setNodata(true);
        }


    }

    return (<>
        <Frame>
            <Typography variant="body1">Voting Report</Typography>
            <SearchForm1 submitCallback={handleSubmit} />
            <div style={{ marginTop: '5px' }}>
                <ShowTable data={data} form={form} />
            </div>
            <Loader showLoader={showLoader} />
            {
                nodata ?
                    <div style={{ textAlign: 'center' }}>No Data Found!</div> : null
            }
        </Frame>
    </>)
}

export default Dashboard;

function ShowTable({ data, form }) {
    if (!form || !data) {
        return <></>;
    }

    if (form.type === 'cumulative') {
        return <Table1 data={data} form={form} />
    }

    if (form.type === 'datewise') {
        return <Table2 data={data} form={form} />
    }
}


function processData(data) {
    let rows = data.votes ?? [];
    rows = rows.map(r => {
        try {
            let i = parseInt(r.count);
            r.count = i;
        } catch (e) {
            r.count = 0;
        }
        return r;
    });

    rows = rows.filter(r => !!r.contestant);

    return rows;
}

function Table1({ data, form }) {

    // let res = (data.votes || []).reduce((accumulator, currentObject) => {
    //     if (!currentObject.contestant || currentObject.contestant.trim() === '' ) {
    //         accumulator.totalCount += currentObject.count;
    //     } else {
    //         accumulator.filteredData.push(currentObject);
    //     }
    //     return accumulator;
    // }, { totalCount: 0, filteredData: [] });
    // res.filteredData.push({ contestant: '', count: res.totalCount });

    let rows = processData(data);
    rows = rows.map(r => ({ id: r.contestant, ...r }));

    let columns = [
        { field: 'contestant', headerName: 'Contestant', width: 350, sortable: true },
        { field: 'count', headerName: 'Votes', width: 150, sortable: true }
    ]

    let CustomToolbar = customToolbar("VotingReport_Cumulative");

    return (<>
        <div style={{ marginTop: '5px', marginBottom: '5px' }}>
            {/*Showing cumulative data from <b>{format(form.startDate, 'PP')}</b> to <b>{format(form.endDate, 'PP')}</b>*/}
            {/*<TotalCard total={data.total} />*/}
            <TotalCard total={rows.length} />
        </div>
        <Grid container spacing={1}>
            <Grid item lg={6}>
                <DataGrid rows={rows} columns={columns} slots={{
                    toolbar: CustomToolbar,
                }}
                    // pageSizeOptions={[25,50]}
                    // initialState={{
                    //     pagination: {
                    //         paginationModel: { page: 1, pageSize: 10 }
                    //     }
                    // }}
                    sortModel={[{
                        field: 'count',
                        sort: 'desc'
                    }]}
                />
            </Grid>
            <Grid item lg={6}>
                {/* Graph should be displayed here */}
                <CumulativeChart data={rows} />
            </Grid>
        </Grid>
    </>)
}

function Table2({ data, form }) {


    let rows = processData(data);
    rows = rows.map(v => ({ id: (v.contestant + v.date), ...v })) || [];

    let columns = [
        { field: 'contestant', headerName: 'Contestant', width: 250, sortable: true },
        { field: 'date', headerName: 'Date', width: 250, sortable: true },
        { field: 'count', headerName: 'Votes', width: 250, sortable: true }
    ]

    let CustomToolbar = customToolbar("VotingReport_Datewise");

    return (<>
        <div style={{ marginTop: '5px', marginBottom: '5px' }}>
            <TotalCard total={rows.length} />
        </div>
        <Grid container spacing={1}>
            <Grid item lg={6}>
                <DataGrid rows={rows} columns={columns} slots={{
                    toolbar: CustomToolbar,
                }}
                />
            </Grid>
            <Grid item lg={6}>
                {/* Graph should be displayed here */}
                <DatewiseChart data={rows} />
            </Grid>
        </Grid>
    </>)
}
